import utility from '@/mixins/utility'

class Issue {

  #data = {}

  #articles = []

  #ctas = []

  #library = {}

  constructor(data={})
  {  
    this.#data = data

    this.#articles = utility.methods.mapModels(data.articles, 'article')

    this.#library = utility.methods.mapModel(data.library, 'library')

    this.#ctas = utility.methods.mapModels(data.issues, 'cta')
  }

  /**
   * Property getters.
   */
  
  get canBuy()
  {
    return this.#data.can_buy
  }

  get canRead()
  {
    return (this.#data.can_read || this.library.canRead)
  }
  
  get cover()
  {
    return this.#data.cover
  }

  get description()
  {
    return this.#data.description
  }

  get embed()
  {
    return this.#data.embed
  }

  get hasBought()
  {
    return this.#data.has_bought
  }

  get id()
  {
    return this.#data.id
  }

  get pdf()
  {
    return this.#data.pdf
  }

  get slug()
  {
    return this.#data.slug
  }

  get store()
  {
    return this.#data.store
  }

  get title()
  {
    return this.#data.title
  }

  /**
   * Relationships.
   */

  get articles()
  {
    return this.#articles
  }

  get ctas()
  {
    return this.#ctas
  }

  get library()
  {
    return this.#library
  }

  /**
   * Computed properties.
   */
  
  get hasFile()
  {
    return ( this.pdf || this.embed )
  }

  /**
   * Methods.
   */

  hasLoadPermission(name)
  {
    let permission = this.#data[name]

    return (typeof permission !== 'undefined')
  }
  
}

export default Issue